import api from './api';
import { ApiError } from '../types';

export interface UserOrganizationResponse {
  organization_id: string;
  role: string;
  [key: string]: any; // Allow for other fields in the response
}

class OrgService {
  // Fetch user's organization information
  async fetchUserOrganization(): Promise<UserOrganizationResponse> {
    try {
      const response = await api.get<UserOrganizationResponse>('/api/org/user');
      const { organization_id, role } = response.data.data;
      
      // Store organization_id in localStorage
      if (organization_id) {
        localStorage.setItem('organization_id', organization_id);
      }
      
      // Store role in localStorage
      if (role) {
        localStorage.setItem('role', role);
      }
      
      return response.data;
    } catch (error) {
      throw this.handleError(error as ApiError);
    }
  }

  // Get stored organization_id from localStorage
  getOrganizationId(): string | null {
    return localStorage.getItem('organization_id');
  }

  // Clear organization_id from localStorage
  clearOrganizationId(): void {
    localStorage.removeItem('organization_id');
  }

  // Check if organization_id exists
  hasOrganizationId(): boolean {
    return !!this.getOrganizationId();
  }

  // Get stored role from localStorage
  getRole(): string | null {
    return localStorage.getItem('role');
  }

  // Clear role from localStorage
  clearRole(): void {
    localStorage.removeItem('role');
  }

  // Check if role exists
  hasRole(): boolean {
    return !!this.getRole();
  }

  // Handle API errors
  handleError(error: ApiError): Error {
    if (error.response) {
      // Server responded with error status
      const { status, data } = error.response;
      
      switch (status) {
        case 401:
          return new Error('Unauthorized. Please login again.');
        case 403:
          return new Error('Access denied. You do not have permission to access organization information.');
        case 404:
          return new Error('Organization information not found.');
        case 500:
          return new Error('Internal server error. Please try again later.');
        default:
          return new Error(data?.message || 'An unexpected error occurred while fetching organization information.');
      }
    } else if (error.request) {
      // Network error
      return new Error('Network error. Please check your internet connection and try again.');
    } else {
      // Other error
      return new Error('An unexpected error occurred while fetching organization information.');
    }
  }
}

const orgService = new OrgService();
export default orgService;

